import { useQuery } from "@tanstack/react-query";
import RequestUtilitario, { BasicQueryType } from "../../../../Utils/RequisicaoUtilitario";
import { AxiosResponse } from "axios";
import OrigemTipo from "../../../../Models/Financeiro/Titulo/Origem/OrigemTipo";
import { Axios } from "../../../Axios";

export function useListar({
    origemTipo,
    ativo,
    ...rest
}:BasicQueryType<AxiosResponse<OrigemTipo[]>, {
    origemTipo?:OrigemTipo,
    ativo?:boolean
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        origemTipo,
        ativo
    });

    return useQuery({
        ...rest,
        queryKey : ["Financeiro.Titulo.Origem.OrigemTipo", `Financeiro.Titulo.Origem.OrigemTipo?${queryString}`],
        queryFn : () => Axios.get<OrigemTipo[]>(`financeiro/titulo/origem/origemTipo${queryString}`),
        select : ({data}) => data,
        staleTime: 1000 * 60 * 60
    });
}